/**
 * Pure helpers for the API Keys settings page (kept out of the component so
 * they're unit-testable — see apiKeysHelpers.test.ts).
 */

/** Epoch seconds → "Jul 27, 2026" (UI display only). */
export function formatKeyDate(epochSeconds: number): string {
  if (!epochSeconds) return '—';
  return new Date(epochSeconds * 1000).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
}

/** Epoch seconds → short relative "last used" label; 0 means never used. */
export function formatLastUsed(epochSeconds: number, neverLabel: string, nowMs = Date.now()): string {
  if (!epochSeconds) return neverLabel;
  const diffSec = Math.max(0, Math.floor(nowMs / 1000) - epochSeconds);
  if (diffSec < 60) return 'just now';
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  if (diffSec < 30 * 86400) return `${Math.floor(diffSec / 86400)}d ago`;
  return formatKeyDate(epochSeconds);
}

/** The curl quickstart shown on the page (uses the real public endpoint). */
export function quickstartCurl(apiKeyPlaceholder = 'vv_live_...'): string {
  return [
    'curl https://api.vivideo.ai/v1/me \\',
    `  -H "Authorization: Bearer ${apiKeyPlaceholder}"`,
  ].join('\n');
}
